//login and logout events
export const TRACK_LOGGED_IN = "Login";
export const TRACK_LOGGED_OUT = "Logout";

//page viewed
export const PAGE_VIEWED = "Page Viewed";

//screen views
export const TRACK_CONTENT_HUB_SCREEN_VIEW = "Content Hub";
export const TRACK_STREAM_CREATE_SCREEN_VIEW = "Stream Create";
export const TRACK_BANNER_CREATE_SCREEN_VIEW = "Banner Create";
export const TRACK_COLLECTION_LIST_SCREEN_VIEW = "Collection List";
export const TRACK_CONTENT_HUB_SWITCH_SCREEN_VIEW = "Content Hub Switch";
export const TRACK_CONTENT_HUB_EDIT_SCREEN_VIEW = "Content Hub Edit";
export const TRACK_SECTION_CREATE_LAYOUT_SCREEN_VIEW = "Section Create Layout";
export const TRACK_SECTION_CREATE_CONTENT_SCREEN_VIEW = "Section Create Content";
export const TRACK_COLLECTION_CREATE_SCREEN_VIEW = "Collection Create";
export const TRACK_COLLECTION_EXPERIENCE_CREATE_SCREEN_VIEW = "Collection Experience Create";
export const TRACK_COLLECTION_VIEWER_CREATE_SCREEN_VIEW = "Collection Viewer Create";
export const TRACK_COLLECTION_DETAIL_SCREEN_VIEW = "Collection Detail";
export const TRACK_ASSET_CREATE_SCREEN_VIEW = "Asset Create";
export const TRACK_ASSET_CREATE_STREAM_COLLECTION_SCREEN_VIEW = "Asset Create Stream Collection";
export const TRACK_ASSET_DETAIL_SCREEN_VIEW = "Asset Detail";
export const TRACK_CONVERSATION_LIST_SCREEN_VIEW = "Conversation List";
export const TRACK_CONVERSATION_DETAIL_SCREEN_VIEW = "Conversation Detail";
export const TRACK_CONVERSATION_PREVIEW_SCREEN_VIEW = "Conversation Preview";
export const TRACK_ASSET_ANALYTICS_SCREEN_VIEW = "Asset Analytics";
export const TRACK_ASSET_EDIT_SCREEN_VIEW = "Asset Edit";
export const TRACK_COMPOSE_SCREEN_VIEW = "Compose";
export const TRACK_REPORT_SCREEN_VIEW = "Reports";
export const TRACK_ASSET_CLONE_SCREEN_VIEW = "Asset Clone";
export const TRACK_GENERATE_LINK_SCREEN_VIEW = "Generate Link";
export const TRACK_SEARCH_SCREEN_VIEW = "Search";
export const TRACK_NOTIFICATIONS_LIST_SCREEN_VIEW = "Notifications List";
export const TRACK_MANAGE_SOURCE_SCREEN_VIEW = "Manage Source";
export const TRACK_SCREEN_VIEW_STREAM_DETAIL = "Stream Detail";
export const TRACK_SCREEN_VIEW_STREAM_SELECTION = "Stream Selection";
export const TRACK_SCREEN_VIEW_STREAM_EDIT = "Stream Edit";
export const TRACK_SCREEN_VIEW_STREAM_DELETE = "Stream Delete";
export const TRACK_SCREEN_VIEW_GROUP_DETAIL = "Group Detail";
export const TRACK_SCREEN_VIEW_CONNECTED_SOURCE = "Connected Source";
export const TRACK_SCREEN_VIEW_MANAGE_USER_ACCESS = "Manage User Access";

export const TRACK_CONTENT_HUB_SECTION_DELETE_CONFIRMATION_SCREEN_VIEW = "Content Hub Section Delete Confirmation";
export const TRACK_CONTENT_HUB_SECTION_CONTENT_CREATE_SELECTION_TYPE_CONFIRMATION_SCREEN_VIEW = "Content Hub Section Content Create Selection Type Confirmation";
export const TRACK_SECTION_SAVE_CONFIRMATION_SCREEN_VIEW = "Section Save Confirmation";
export const TRACK_BANNER_LIST_SCREEN_VIEW = "Banner List";
export const TRACK_COLLECTION_CLONE_CONFIRMATION_SCREEN_VIEW = "Collection Clone Confirmation";
export const TRACK_COLLECTION_ADD_LOGO_SCREEN_VIEW = "Collection Add Logo";
export const TRACK_COLLECTION_EDIT_BANNER_SCREEN_VIEW = "Collection Edit Banner";
export const TRACK_SECTION_CREATE_SCREEN_VIEW = "Section Create";
export const TRACK_COLLABORATE_EDIT_SCREEN_VIEW = "Collaborate Edit";
export const TRACK_LIVE_COLLECTION_CONFIRM_SCREEN_VIEW = "Live Collection Confirm";
export const TRACK_ADD_COLLECTION_LIST_SCREEN_VIEW = "Collection List";
export const TRACK_SETTINGS_SCREEN_VIEW = "Settings";
export const TRACK_CONTENT_MAP_SCREEN_VIEW = "Content Map";

export const TRACK_DEAL_ROOM_LIST_VIEW = "Deal Room List";
export const TRACK_DEAL_ROOM_DETAIL_VIEW = "Deal Room Detail";
export const TRACK_DEAL_ROOM_CREATE_VIEW = "Deal Room Create";
export const TRACK_DEAL_ROOM_ADD_MEETING_LINK_VIEW = "Add Meeting Link";
export const TRACK_DEAL_ROOM_DETAIL_ASSET_SECTION_VIEW = "Deal Room Detail Asset Section";
export const TRACK_DEAL_ROOM_PEOPLE_SECTION_VIEW = "Deal Room People Section";
export const TRACK_DEAL_ROOM_ACTIVITY_SECTION_VIEW = "Deal Room Activity Section";
export const TRACK_DEAL_ROOM_ENGAGE_SECTION_VIEW = "Deal Room Engage Section";
export const TRACK_DEAL_ROOM_CLONE_CONFIRMATION_SCREEN_VIEW = "Deal Room Clone Confirmation";

//content hub events
export const TRACK_CONTENT_HUB_CREATE_STREAM_CLICKED_EVENT = "Create Stream Clicked";
export const TRACK_CONTENT_HUB_ADD_COVER_IMAGE_CLICKED_EVENT = "Add Cover Image Clicked";
export const TRACK_CONTENT_HUB_COVER_IMAGE_ADDED = "Cover Image Added";
export const TRACK_CONTENT_HUB_EDIT_HUB_CLICKED_EVENT = "Edit Hub Clicked";
export const TRACK_CONTENT_HUB_MANAGE_CONTENT_CLICKED = "Manage Content Clicked";
export const TRACK_CONTENT_HUB_CREATE_NEW_SECTION_CLICKED = "Create New Section Clicked";
export const TRACK_CONTENT_HUB_SECTION_MANAGE_CONTENT_CLICKED = "Section Manage Content Clicked";
export const TRACK_CONTENT_HUB_SECTION_CONTENT_SELECT_CLICKED = "Section Content Select Clicked";
export const TRACK_CONTENT_HUB_DELETE_SECTION_CLICKED = "Delete Section Clicked";
export const TRACK_CONTENT_HUB_SECTION_DELETED_CLICKED = "Section Deleted";

export const TRACK_CONTENT_SECTION_MOVED = "Section Moved";
export const TRACK_CONTENT_HUB_SECTION_SAVE_CLICKED = "Section Save Clicked";
export const TRACK_CONTENT_HUB_SECTION_SAVE_CONFIRM_CLICKED = "Section Save Confirm Clicked";
export const TRACK_CONTENT_HUB_SECTION_EDITED = "Section Edited";
export const TRACK_CONTENT_HUB_SECTION_CREATED = "Section Created";
export const TRACK_CONTENT_HUB_SECTION_CONTENT_ADDED_EVENT = "Section Content Added";
export const TRACK_CONTENT_HUB_SECTION_CONTENT_REMOVED_EVENT = "Section Content Removed";
export const TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_SAVED = "Section Content Selection Saved";
export const TRACK_CONTENT_HUB_SWITCH_CLICKED = "Hub Switch Clicked";
export const TRACK_CONTENT_HUB_CLONE_HUB_CLICKED_EVENT = "Clone Hub Clicked";
export const TRACK_CONTENT_HUB_CLONED_EVENT = "Content Hub Cloned";
export const TRACK_CONTENT_HUB_EDITED_EVENT = "Content Hub Edited";
export const TRACK_CONTENT_HUB_SWITCHED = "Content Hub Switched";
export const TRACK_CONTENT_HUB_CREATE_ASSET_CLICKED = "Create Asset Clicked";
export const TRACK_CONTENT_HUB_ASSET_TYPE_SELECTED = "Asset Type Selected";
export const TRACK_CONTENT_HUB_CONTENT_MAP_CLICKED_EVENT = "Content Map Clicked";
export const TRACK_CONTENT_HUB_EDIT_CONTENT_CLICKED_EVENT = "Edit Content Clicked";
export const TRACK_CONTENT_HUB_DELETE_CONTENT_CLICKED = "Delete Content Clicked";
export const TRACK_CONTENT_SECTION_CLICKED_EVENT = "Content Section Clicked";
export const TRACK_CONTENT_FILTERED_EVENT = "Content Filtered";
export const TRACK_CONTENT_HUB_STREAM_CREATED_EVENT = "Stream Created";
export const TRACK_CONTENT_HUB_DESTINATION_SELECTED = "Destination Selected";
export const TRACK_CONTENT_HUB_ASSET_CREATED_EVENT = "Asset Created";
export const TRACK_CONTENT_HUB_STREAM_CONTENT_LAYOUT_SELECTED_EVENT = "Section Content Layout Selected";
export const TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_TYPE_SELECTED_EVENT = "Section Content Selection Type Selected";
export const TRACK_CONTENT_HUB_SECTION_CONTENT_SELECTION_TYPE_CONFIRMED = "Section Content Selection Type Confirmed";

//stream and group events
export const TRACK_STREAM_VIEWED_EVENT = "Stream Detail Viewed";
export const TRACK_GROUP_VIEWED_EVENT = "Group Detail Viewed";
export const TRACK_STREAM_ADDED_EVENT = "Stream Added";
export const TRACK_ADD_GROUP_CLICKED_EVENT = "Add Group Clicked";
export const TRACK_ADD_GROUP_CONFIRM_CLICKED_EVENT = "Add Group Confirm Clicked";
export const TRACK_GROUP_ADDED_EVENT = "Group Added";
export const TRACK_ADD_ASSET_CLICKED_EVENT = "Add Asset Clicked";
export const TRACK_RENAME_CLICKED_EVENT = "Rename Clicked";
export const TRACK_RENAME_CONFIRM_CLICKED_EVENT = "Rename Confirm Clicked";
export const TRACK_ASSET_RENAMED_EVENT = "Asset Renamed";

export const TRACK_GROUP_RENAMED_EVENT = "Group Renamed";
export const TRACK_DELETE_CLICKED_EVENT = "Delete Clicked";
export const TRACK_DELETE_CONFIRM_CLICKED_EVENT = "Delete Confirm Clicked";
export const TRACK_ASSET_DELETED_EVENT = "Asset Deleted";
export const TRACK_GROUP_DELETED_EVENT = "Group Deleted";
export const TRACK_COPY_CLICKED_EVENT = "Copy Clicked";
export const TRACK_COPY_CONFIRM_CLICKED_EVENT = "Copy Confirm Clicked";
export const TRACK_COPY_STREAM_SELECTED_EVENT = "Copy Stream Selected";
export const TRACK_ASSET_COPIED_EVENT = "Asset Copied";
export const TRACK_GROUP_COPIED_EVENT = "Group Copied";

export const TRACK_MOVE_CLICKED_EVENT = "Move Clicked";
export const TRACK_MOVE_CONFIRM_CLICKED_EVENT = "Move Confirm Clicked";
export const TRACK_MOVE_STREAM_SELECTED_EVENT = "Move Stream Selected";
export const TRACK_ASSET_MOVED_EVENT = "Asset Moved";
export const TRACK_GROUP_MOVED_EVENT = "Group Moved";
export const TRACK_MANAGE_SOURCE_CLICKED_EVENT = "Manage Source Clicked";
export const TRACK_MAP_NEW_FOLDER_CLICKED_EVENT = "Map New Folder Clicked";
export const TRACK_CONNECTED_SOURCE_SELECTED_EVENT = "Connected Source Selected";
export const TRACK_FOLDER_SELECTED_EVENT = "Folder Selected";
export const TRACK_SOURCE_ADDED_EVENT = "Source Added";

export const TRACK_EDIT_GROUP_CLICKED_EVENT = "Edit Group Clicked";
export const TRACK_GROUP_EDITED_EVENT = "Group Edited";
export const TRACK_EDIT_STREAM_CLICKED_EVENT = "Edit Stream Clicked";
export const TRACK_EDIT_STREAM_CONFIRM_CLICKED_EVENT = "Edit Stream Confirm Clicked";
export const TRACK_CHANGE_BACKGROUND_CLICKED_EVENT = "Change Background Clicked";
export const TRACK_ADD_BANNER_CLICKED_EVENT = "Add Banner Clicked";
export const TRACK_CONTENT_HUB_ADD_BANNER_CLICKED_EVENT = "Add Banner Clicked";
export const TRACK_BANNER_CONTENT_SELECTED_EVENT = "Banner Content Selected";
export const TRACK_CROP_BANNER_CLICKED_EVENT = "Crop Banner Clicked";
export const TRACK_BANNER_CROPPED_EVENT = "Banner Cropped";
export const TRACK_BANNER_ADDED_EVENT = "Banner Added";
export const TRACK_BACKGROUND_IMAGE_ADDED_EVENT = "Background Image Added";
export const TRACK_STREAM_EDITED_EVENT = "Stream Edited";
export const TRACK_DELETE_STREAM_CLICKED_EVENT = "Delete Stream Clicked";

export const TRACK_DELETE_STREAM_CONFIRM_CLICKED_EVENT = "Delete Stream Confirm Clicked";
export const TRACK_STREAM_DELETED_EVENT = "Stream Deleted";
export const TRACK_MANAGE_USER_ACCESS_CLICKED_EVENT = "Manage User Access Clicked";
export const TRACK_USER_ACCESS_UPDATED_EVENT = "User Access Updated";

//collection events
export const TRACK_COLLECTION_VIEWED_EVENT = "Collection Viewed";
export const TRACK_COLLECTION_CREATED_EVENT = "Collection Created";
export const TRACK_COLLECTION_SHARED_EVENT = "Collection Shared";
export const TRACK_ASSET_DOWNLOADED_EVENT = "Asset Downloaded";
export const TRACK_ASSET_SHARE_LINK_GENERATED_EVENT = "Asset Share Link Generated";
export const TRACK_CREATE_COLLECTION_CLICKED_EVENT = "Create Collection Clicked";
export const TRACK_CHANGE_EXPERIENCE_CLICKED_EVENT = "Change Experience Clicked";
export const TRACK_EXPERIENCE_TYPE_SELECTED_EVENT = "Experience Type Selected";
export const TRACK_VIEWER_TYPE_SELECTED_EVENT = "Viewer Type Selected";
export const TRACK_COLLECTION_FILTERED_EVENT = "Collection Filtered";
export const TRACK_CREATE_FOLDER_CLICKED_EVENT = "Create Folder Clicked";
export const TRACK_FOLDER_CREATED_EVENT = "Folder Created";
export const TRACK_RENAME_COLLECTION_CLICKED = "Rename Collection Clicked";
export const TRACK_COLLECTION_RENAMED_EVENT = "Collection Renamed";
export const TRACK_DELETE_COLLECTION_CLICKED = "Delete Collection Clicked";
export const TRACK_COLLECTION_DELETED_EVENT = "Collection Deleted";
export const TRACK_CLONE_COLLECTION_CLICKED_EVENT = "Clone Collection Clicked";
export const TRACK_EDIT_COLLECTION_CLICKED_EVENT = "Edit Collection Clicked";
export const TRACK_ADD_LOGO_CLICKED_EVENT = "Add Logo Clicked";
export const TRACK_ADD_LOGO_UPLOAD_CLICKED_EVENT = "Add Logo Upload Clicked";
export const TRACK_LOGO_UPLOADED_EVENT = "Logo Uploaded";
export const TRACK_EDIT_BANNER_CLICKED_EVENT = "Edit Banner Clicked";
export const TRACK_CHANGE_EXPERIENCE_CLICKED = "Change Experience Clicked";
export const TRACK_CLONE_COLLECTION_CONFIRMATION_EVENT = "Clone Collection Confirmed";
export const TRACK_COLLECTION_CLONED_EVENT = "Collection Cloned";

export const TRACK_BANNER_ADDED_COLLECTION_EVENT = "Banner Added";
export const TRACK_FILTER_BANNER_CLICKED_EVENT = "Filter Banner Clicked";
export const TRACK_ADD_SECTION_CLICKED_COLLECTION_EVENT = "Add Section Clicked";
export const TRACK_GENERATE_LINK_CLICKED_EVENT = "Generate Link Clicked";
export const TRACK_ADD_ASSET_CLICKED_COLLECTION_EVENT = "Add Asset Clicked";
export const TRACK_LIVE_COLLECTION_TOGGLE_CLICKED_EVENT = "Live Collection Toggle Clicked";
export const TRACK_LIVE_COLLECTION_TOGGLED_EVENT = "Live Collection Toggled";
export const TRACK_TEMPLATE_TOGGLE_CLICKED_EVENT = "Template Toggle Clicked";
export const TRACK_INTERNAL_USE_ONLY_CLICKED_EVENT = "Internal Use Only Toggle Clicked";
export const TRACK_INTERNAL_USE_ONLY_TOGGLED_EVENT = "Internal Use Only Toggled";
export const TRACK_COLLABORATE_CLICKED_EVENT = "Collaborate Clicked";
export const TRACK_COLLABORATORS_UPDATED_EVENT = "Collaborators Updated";
export const TRACK_TEMPLATE_TOGGLED_EVENT = "Template Toggled";
export const TRACK_SECTION_ADDED_EVENT = "Section Added";
export const TRACK_SECTION_SELECTED_EVENT = "Section Selected";
export const TRACK_MORE_OPTIONS_CLICKED_EVENT = "More Options Clicked";
export const TRACK_SHARE_COLLECTION_CLICKED = "Share Collection Clicked";
export const TRACK_BANNER_FILTERED_EVENT = "Banner Filtered";

//asset events
export const TRACK_ASSET_VIEWED_EVENT = "Asset Detail Viewed";
export const TRACK_ASSET_ANALYTICS_VIEWED_EVENT = "Asset Analytics";
export const TRACK_ASSET_SOURCE_SELECTED_EVENT = "Asset Source Selected";
export const TRACK_ASSET_SELECTED_EVENT = "Asset Selected";
export const TRACK_ASSET_SHARED_EVENT = "Asset Shared";
export const TRACK_ASSET_ADDED = "Asset Added";
export const TRACK_ASSET_SHARE_CLICKED_EVENT = "Asset Share Clicked";
export const TRACK_ASSET_DOWNLOAD_CLICKED = "Asset Download Clicked";
export const TRACK_GENERATE_LINK_CLICKED = "Generate Link Clicked";
export const TRACK_ANALYTICS_CLICKED_EVENT = "Analytics Clicked";
export const TRACK_ADD_TO_COLLECTION_CLICKED_EVENT = "Add To Collection Clicked";
export const TRACK_COLLECTION_SELECTED_EVENT = "Collection Selected";
export const TRACK_ASSET_ADDED_TO_COLLECTION_EVENT = "Asset Added To Collection";
export const TRACK_EDIT_ASSET_CLICKED_EVENT = "Edit Asset Clicked";
export const TRACK_ASSET_EDITED_EVENT = "Asset Edited";
export const TRACK_CLONE_ASSET_CLICKED_EVENT = "Clone Asset Clicked";
export const TRACK_ASSET_CLONED_EVENT = "Asset Cloned";
export const TRACK_EDIT_IMAGE_CLICKED_EVENT = "Edit Image Clicked";
export const TRACK_ADD_PAGES_CLICKED_EVENT = "Add Pages Clicked";
export const TRACK_DESTINATION_SELECTED = "Destination Selected";
export const TRACK_PAGE_ADDED_EVENT = "Page Added";
export const TRACK_DOCUMENT_EDIT_CLICKED_EVENT = "Document Edit clicked";
export const TRACK_ASSET_SCREEN_VIEW = "Asset Detail";

//generate link events
export const TRACK_GENERATE_LINK_EVENT = "Get Link Clicked";

//settings events
export const TRACK_CUSTOM_FIELD_CLICKED_EVENT = "Add Custom Field Clicked";
export const TRACK_CUSTOM_FIELD_CREATED_EVENT = "Custom Field Created";
export const TRACK_CREATE_USER_GROUP_CLICKED_EVENT = "Create User Group Clicked";
export const TRACK_USER_GROUP_CREATED_EVENT = "User Group Created";
export const TRACK_INTEGRATIONS_FILTERED_EVENT = "Integrations Filtered";
export const TRACK_INTEGRATION_PARTNER_SELECTED_EVENT = "Integration Partner Selected";
export const TRACK_CONTENT_SOURCE_CLICKED_EVENT = "Content Source Clicked";
export const TRACK_INTEGRATIONS_CLICKED_EVENT = "Integrations Clicked";
export const TRACK_SOURCE_TYPE_SELECTED_EVENT = "Source Type Selected";
export const TRACK_PLUGIN_CONNECTED_EVENT = "Plugin Connected";
export const TRACK_SOURCE_CONNECTED_EVENT = "Source Connected";

//content searched events
export const TRACK_CONTENT_SEARCH_EVENT = "Content Searched";
export const TRACK_IN_ASSET_SEARCH_EVENT = "Content Searched";

//conversations events
export const TRACK_CONVERSATION_VIEWED_EVENT = "Conversation Viewed";
export const TRACK_CONVERSATION_CLICKED_EVENT = "Conversation Clicked";

//reports events
export const TRACK_REPORTS_VIEWED_EVENT = "Reports Viewed";
export const TRACK_REPORTS_TOGGLED_VIEW_EVENT = "Reports View Toggled";

//compose events
export const TRACK_CONVERSATION_SENT = "Conversation Sent";
export const TRACK_ATTACH_DOCUMENTS_CLICKED_COMPOSE_EVENT = "Attach Documents Clicked";
export const TRACK_INSERT_WIDGET_CLICKED_COMPOSE_EVENT = "Insert Widget Clicked";
export const TRACK_SELECT_TEMPLATE_CLICKED_COMPOSE_EVENT = "Select Template Clicked";
export const TRACK_TEMPLATE_SELECTED_EVENT = "Template Selected";
export const TRACK_RECOMMENDED_ASSET_CLICKED = "Recommended Asset Clicked";
export const TRACK_WIDGET_INSERTED_COMPOSE_EVENT = "Widget Inserted";

//search and seek events
export const TRACK_SEEK_VIEW_CLICKED_EVENT = "Seek View Clicked";
export const TRACK_NEW_CHAT_CLICKED_EVENT = "New Chat Clicked";
export const TRACK_SEARCH_REACTED_EVENT = "Search Reacted";
export const TRACK_SEEK_SESSIONS_CLICKED_EVENT = "Seek History Clicked";
export const TRACK_SEEK_SESSIONS_DELETED_EVENT = "Seek History Deleted";
export const TRACK_DRAFT_AN_EMAIL_CLICKED_EVENT = "Draft An Email Clicked";
export const TRACK_SEEK_HISTORY_DELETED_EVENT = "Seek History Deleted";
export const TRACK_SEEK_PROMPT_CLICKED_EVENT = "Seek Prompt Clicked";

//in-asset seek events
export const TRACK_ASSET_SUMMARISE_CLICKED_EVENT = "Asset Summarise Clicked";
export const TRACK_ASSET_QUESTION_CLICKED_EVENT = "Asset Question Clicked";

//engage events
export const TRACK_ENGAGE_CLICKED_EVENT = "Engage Clicked";
export const TRACK_VIEWER_FILTER_APPLIED_EVENT = "Viewer Filter Applied";
export const TRACK_MAP_FILTER_APPLIED_EVENT = "Map Filter Applied";
export const TRACK_ALL_RECIPIENTS_TOGGLED_EVENT = "All Recipients Toggled";
export const TRACK_RECIPIENT_SELECTED_EVENT = "Recipient Selected";
export const TRACK_MESSAGE_SENT_EVENT = "Message Sent";

//content map events
export const TRACK_FILTER_CLUSTER_CREATED_EVENT = "Filter Cluster Created";
export const TRACK_FILTER_CLUSTER_SELECTED_EVENT = "Filter Cluster Selected";
export const TRACK_FILTER_CLUSTER_UPDATED_EVENT = "Filter Cluster Updated";
export const TRACK_FILTER_CLUSTER_DELETE_CLICKED_EVENT = "Filter Cluster Delete Clicked";
export const TRACK_FILTER_CLUSTER_DELETED_EVENT = "Filter Cluster Deleted";
export const TRACK_BULK_ASSET_SELECTED_EVENT = "Bulk Asset Selected";
export const TRACK_BULK_ASSET_EDITED_EVENT = "Bulk Asset Edited";
export const TRACK_BULK_ASSET_DELETED_EVENT = "Bulk Asset Deleted";
export const TRACK_EXPORT_CLICKED_EVENT = "Export Clicked";
export const TRACK_CONTENT_MAP_EXPORTED_EVENT = "Content Map Exported";

//deal room events
export const TRACK_CREATE_DEAL_ROOM_CLICKED_EVENT = "Create Deal Room Clicked";
export const TRACK_DEAL_ROOM_CREATED_EVENT = "Deal Room Created";
export const TRACK_DEAL_ROOM_SEARCHED_EVENT = "Deal Room Searched";
export const TRACK_DEAL_ROOM_RENAMED_EVENT = "Deal Room Renamed";
export const TRACK_DEAL_ROOM_DELETED_EVENT = "Deal Room Deleted";
export const TRACK_DEAL_ROOM_EDIT_CLICKED_EVENT = "Deal Room Edit Clicked";
export const TRACK_DEAL_ROOM_EDITED_EVENT = "Deal Room Edited";
export const TRACK_DEAL_ROOM_SORTED_EVENT = "Deal Room Sorted";

export const TRACK_DEAL_ROOM_OVERVIEW_CLICKED_EVENT = "Deal Room Overview Clicked";
export const TRACK_DEAL_ROOM_OVERVIEW_ADDED_EVENT = "Deal Room Overview Added";
export const TRACK_DEAL_ROOM_ASSETS_CLICKED_EVENT = "Assets Clicked";
export const TRACK_DEAL_ROOM_USERS_CLICKED_EVENT = "Deal Room Users Clicked";
export const TRACK_DEAL_ROOM_USERS_ADDED_EVENT = "Deal Room Users Added";
export const TRACK_DEAL_ROOM_MEETING_LINK_CLICKED_EVENT = "Meeting Link Clicked";
export const TRACK_DEAL_ROOM_MEETING_LINK_ADDED_EVENT = "Meeting Link Added";

export const TRACK_DEAL_ROOM_ENGAGE_CLICKED_EVENT = "Engage Clicked";
export const TRACK_DEAL_ROOM_SHORTCUTS_CLICKED_EVENT = "Deal Room Shortcuts Clicked";
export const TRACK_DEAL_ROOM_ACTIVITY_CLICKED_EVENT = "Activity Clicked";
export const TRACK_DEAL_ROOM_SHARED_EVENT = "Deal Room Shared";

//settings dashboard
export const TRACK_NOTIFY_USERS_CLICKED_EVENT = "Notify Users Clicked";
export const TRACK_MANAGE_TECH_STACK_CLICKED_EVENT = "Manage Tech Stack Clicked";
export const TRACK_CONTENT_MODERATORS_ADDED_EVENT = "Content Moderators Added";
export const TRACK_TECH_STACK_ADDED_EVENT = "Tech Stack Added";

export const TRACK_CLONE_DEAL_ROOM_CLICKED_EVENT = "Clone Deal Room Clicked";
export const TRACK_CLONE_DEAL_ROOM_CONFIRMATION_EVENT = "Clone Deal Room Confirmed";
export const TRACK_DEAL_ROOM_CLONED_EVENT = "Deal Room Cloned";


// settings profile
export const TRACK_EMAIL_SIGNATURE_ADDED_EVENT = "Email Signature Added";
export const TRACK_PROFILE_CLICKED_EVENT = "Profile Clicked";